<ng-container [ngSwitch]="phase">
  <sbnb-connect-vrbo-start
    *ngSwitchDefault
    [loading]="loading"
    (phaseComplete)="phase0Complete($event)"></sbnb-connect-vrbo-start>

  <sbnb-connect-vrbo-phase1
    *ngSwitchCase="1"
    [loading]="loading"
    [mode]="mode"
    [username]="username"
    (phaseComplete)="phase1Complete($event)"></sbnb-connect-vrbo-phase1>

  <sbnb-connect-shared-twofa
    *ngSwitchCase="2"
    platform="Vrbo"
    [loading]="loading"
    [verificationData]="verificationData"
    (phaseComplete)="phase2Complete($event)"></sbnb-connect-shared-twofa>

  <sbnb-connect-set-markup *ngSwitchCase="3" platform="homeaway" (stepComplete)="phase = 4"></sbnb-connect-set-markup>

  <sbnb-connect-done
    *ngSwitchCase="4"
    platform="homeaway"></sbnb-connect-done>
</ng-container>
